// @flow
import React, {memo, useEffect} from 'react';

import {InputBase, makeStyles} from '@material-ui/core';
import {colors} from '../../../../../../../../assets/styles/colors';

import {useFormContext} from 'react-hook-form';

import type {Theme, InputBaseProps} from '@material-ui/core';

type Props = {
  onSubmit: (e: any) => void,
  disabled?: boolean,
} & InputBaseProps;

const useStyles = props =>
  makeStyles((theme: Theme) => ({
    root: {
      '& .MuiFilledInput-adornedStart': {
        paddingLeft: 0,
      },
      '& .MuiFilledInput-input': {
        paddingLeft: '32px!important',
      },
    },
    searchInput: {
      pointerEvents: props.disabled ? 'none' : '',
      opacity: props.disabled ? '0.5' : '',
      padding: theme.spacing(0, 2),
      borderRadius: '.5rem',
      background: colors.grey300,
      border: 'none',
      outline: 'none',
      minHeight: 40,
      maxHeight: 125,
      width: '100%',
      fontSize: 'medium',
      lineHeight: 'normal',
      overflowY: 'hidden',

      '& > textarea': {
        padding: 0,
        overflowY: 'auto !important',
        maxHeight: 'inherit',

        '&::-webkit-scrollbar': {
          width: '5px',
          height: '5px',
        },

        '&::-webkit-scrollbar-track': {
          background: colors.grey200,
          borderRadius: '5px',
        },

        '&::-webkit-scrollbar-thumb': {
          background: colors.grey400,
          borderRadius: '5px',
        },
      },
    },
  }));

export default memo<Props>(NewMessageInput);

const NEW_MESSAGE_INPUT_ID = 'new-message-input';

function NewMessageInput(props: Props) {
  const {onSubmit, disabled, autoFocus, ...otherProps} = props;
  const classes = useStyles({disabled})();

  const {register} = useFormContext();

  const handleEnterKey = e => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.value = '';
    onSubmit(e);
  };

  useEffect(() => {
    if (autoFocus) {
      const input = document.getElementById(NEW_MESSAGE_INPUT_ID);
      if (input) {
        input.focus();
      }
    }
  }, [autoFocus]);

  return (
    <div className={classes.root}>
      <InputBase
        className={classes.searchInput}
        type="text"
        id={NEW_MESSAGE_INPUT_ID}
        name="message"
        multiline
        onKeyPress={e => {
          if (e.key === 'Enter' && !e.shiftKey) handleEnterKey(e);
        }}
        // maxRows={5}
        // disabled={disabled}
        {...otherProps}
        inputRef={register()}
      />
    </div>
  );
}
